export default function(error) {
  if (error.response) {
    return error.response.status
  } else if (error.request) {
    return 500
  } else {
    return 500
  }
}
